export default {"src":"/_next/static/media/LinkIconWhite.8577212e.svg","height":32,"width":32};